import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Vue from "vue";
import { updateField } from "@joandvgv/vuex-map-fields";
import marketingState from "./marketing-state";
import { isUndefined, cloneDeep } from "lodash";
export const CLEAR_CURRENT_LIST = "CLEAR_CURRENT_LIST";
export const SET_MARKETING_CAMPAIGNS = "SET_MARKETING_CAMPAIGNS";
export const SET_AUTOMATION_CRITERIA = "SET_AUTOMATION_CRITERIA";
export const SET_CURRENT_EMAIL_ID = "SET_CURRENT_EMAIL_ID";
export const SET_MARKETING_EMAILS = "SET_MARKETING_EMAILS";
export const EMPTY_CURRENT_EMAIL = "EMPTY_CURRENT_EMAIL";
export const SET_LISTS = "SET_LISTS";
export const UPDATE_MARKETING_EMAILS = "UPDATE_MARKETING_EMAILS";
export const SET_CURRENT_LIST = "SET_CURRENT_LIST";
export const SET_SEGMENT_LIST = "SET_SEGMENT_LIST";
export const SET_SEGMENT_DATA = "SET_SEGMENT_DATA";
export const DELETE_SEGMENT = "DELETE_SEGMENT";
export const SET_EMAIL_SUBSCRIBED_ALL = "SET_EMAIL_SUBSCRIBED_ALL";
export const SET_EMAIL_SUBSCRIBED_SEGMENT = "SET_EMAIL_SUBSCRIBED_SEGMENT";
export const SET_CAMPAIGN_STATISTICS = "SET_CAMPAIGN_STATISTICS";
export const SET_MARKETING_CAMPAIGN = "SET_MARKETING_CAMPAIGN";
export const SET_SEGMENTS_TRANSLATION_MAP = "SET_SEGMENTS_TRANSLATION_MAP";
const mutations = {
  [CLEAR_CURRENT_LIST]: state => {
    state.currentList = _objectSpread({}, marketingState.currentList);
  },
  [SET_CURRENT_LIST]: (state, details) => {
    state.currentList = _objectSpread(_objectSpread({}, state.currentList), details);
  },
  [SET_MARKETING_CAMPAIGNS]: (state, campaigns) => {
    state.campaigns = _objectSpread(_objectSpread({}, state.campaigns), campaigns);
  },
  [SET_AUTOMATION_CRITERIA]: (state, {
    criteria
  }) => {
    state.automationCriteria = criteria;
  },
  [SET_CURRENT_EMAIL_ID]: (state, {
    emailId
  }) => {
    state.currentEmail = _objectSpread(_objectSpread({}, state.currentEmail), {}, {
      emailId
    });
  },
  [UPDATE_MARKETING_EMAILS]: (state, {
    emailId,
    email
  }) => {
    var _context;
    if (!_includesInstanceProperty(_context = state.marketingEmails.allIds).call(_context, emailId)) state.marketingEmails.allIds.push(emailId);
    state.marketingEmails.byId = _objectSpread(_objectSpread({}, state.marketingEmails.byId), {}, {
      [emailId]: email
    });
  },
  [SET_MARKETING_EMAILS]: (state, emails) => {
    state.marketingEmails = emails;
  },
  [EMPTY_CURRENT_EMAIL]: state => {
    state.currentEmail = {
      emailId: "",
      email: "",
      verified: false,
      updatedAt: ""
    };
  },
  [SET_LISTS]: (state, lists) => {
    state.lists = lists;
  },
  [SET_SEGMENT_DATA]: (state, segments) => {
    state.segments = segments;
  },
  [SET_SEGMENT_LIST]: (state, list) => {
    state.currentList.segmentedLists = _objectSpread(_objectSpread({}, state.currentList.segmentedLists), list);
  },
  [DELETE_SEGMENT]: (state, {
    segmentIndex
  }) => {
    const newSegments = cloneDeep(state.currentList.segments);
    _spliceInstanceProperty(newSegments).call(newSegments, segmentIndex, 1);
    newSegments.forEach((segment, i) => segment.id = i + 1);
    state.currentList.segments = newSegments;
  },
  [SET_EMAIL_SUBSCRIBED_ALL]: (state, {
    suppressed,
    emailId
  }) => {
    var _context2;
    const listIndex = _findIndexInstanceProperty(_context2 = state.currentList.list).call(_context2, contact => contact.emailId === emailId);
    const emailObj = _objectSpread(_objectSpread({}, state.currentList.list[listIndex]), suppressed);
    Vue.set(state.currentList.list, listIndex, emailObj);
  },
  [SET_EMAIL_SUBSCRIBED_SEGMENT]: (state, {
    suppressed,
    emailId,
    segmentId
  }) => {
    var _context3;
    const listIndex = _findIndexInstanceProperty(_context3 = state.currentList.segmentedLists[segmentId].list).call(_context3, contact => contact.emailId === emailId);
    const emailObj = _objectSpread(_objectSpread({}, state.currentList.segmentedLists[segmentId].list[listIndex]), suppressed);
    Vue.set(state.currentList.segmentedLists[segmentId].list, listIndex, emailObj);
  },
  [SET_CAMPAIGN_STATISTICS]: (state, {
    campaignId,
    statistics
  }) => {
    state.campaigns.byId[campaignId].statistics = statistics;
  },
  [SET_SEGMENTS_TRANSLATION_MAP]: (state, {
    translationMap
  }) => {
    Vue.set(state, "segmentsTranslationMap", translationMap);
  },
  [SET_MARKETING_CAMPAIGN]: (state, campaignDetails) => {
    if (isUndefined(state.campaigns.byId[campaignDetails.campaignId])) state.campaigns.allIds.push(campaignDetails.campaignId);
    Vue.set(state.campaigns.byId, campaignDetails.campaignId, campaignDetails);
  },
  updateField
};
export default mutations;